export const circleSize = (size: number) => ({
  width: size,
  height: size,
  minWidth: size,
  minHeight: size,
  maxWidth: size,
  maxHeight: size,
  borderRadius: size / 2
});
